import React from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n/LanguageContext';
import LanguageSwitch from './LanguageSwitch';
import siteImageManifest from '../data/siteImageManifest.generated.json';

export default function Header() {
  const { t } = useI18n();
  const v = typeof siteImageManifest?.generatedAt === 'string' ? siteImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';
  const catalogFileName = 'Catalog Online Younger Karom.pdf';
  const catalogHref = `${process.env.PUBLIC_URL}/images/altele/${encodeURIComponent(catalogFileName)}${suffix}`;
  const catalogDownloadName = v ? `Catalog Online Younger Karom_${v.slice(0, 10)}.pdf` : catalogFileName;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  function closeMenu() {
    setIsMenuOpen(false);
  }

  function toggleMenu() {
    setIsMenuOpen((v) => !v);
  }

  return (
    <header className={isMenuOpen ? 'yk-header is-menuOpen' : 'yk-header'}>
      <div className="yk-container yk-headerInner">
        <NavLink to="/" className="yk-brand" aria-label={t('common.companyName')}>
          <img
            className="yk-brandLogo"
            src={`${process.env.PUBLIC_URL}/brand/yk-logo.png${suffix}`}
            alt={t('common.companyName')}
          />
        </NavLink>

        <nav className="yk-nav" id="yk-mobileNav" aria-label="Primary">
          <NavLink
            to="/"
            end
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'yk-navLink is-active' : 'yk-navLink')}
          >
            {t('nav.home')}
          </NavLink>
          <NavLink
            to="/misiunea-noastra"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'yk-navLink is-active' : 'yk-navLink')}
          >
            {t('nav.mission')}
          </NavLink>
          <NavLink
            to="/produse/sticle-pet"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'yk-navLink is-active' : 'yk-navLink')}
          >
            {t('nav.products')}
          </NavLink>
          <NavLink
            to="/matrita-personalizata"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'yk-navLink is-active' : 'yk-navLink')}
          >
            {t('nav.customMold')}
          </NavLink>
          <a
            href={catalogHref}
            download={catalogDownloadName}
            onClick={closeMenu}
            className="yk-navLink yk-navLinkCatalog"
            aria-label={t('nav.catalog')}
          >
            <img className="yk-downloadIcon" src={`${process.env.PUBLIC_URL}/images/altele/arrow.png${suffix}`} alt="" aria-hidden="true" />
            <span>{t('nav.catalog')}</span>
          </a>
          <NavLink
            to="/contact"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'yk-navLink is-active' : 'yk-navLink')}
          >
            {t('nav.contact')}
          </NavLink>
        </nav>

        <div className="yk-headerActions">
          <button
            type="button"
            className={isMenuOpen ? 'yk-menuBtn is-active' : 'yk-menuBtn'}
            onClick={toggleMenu}
            aria-haspopup="true"
            aria-expanded={isMenuOpen}
            aria-controls="yk-mobileNav"
          >
            {t('nav.menu')}
          </button>
          <LanguageSwitch />
        </div>
      </div>
    </header>
  );
}
